// Retken hylkäämisen varmistusteksti: kertoo, mitä hylkäys poistaa, jotta päätös tehdään tietoisesti.
// Luvut tulevat käynnissä olevasta retkestä (Recorder.snapshot().active).

const plural = (n, one, many) => `${n.toLocaleString("fi-FI")} ${n === 1 ? one : many}`;

/** Alle tämän matkan retkellä ei ole "mitään menetettävää" (vahingossa aloitettu retki). */
export const NOTHING_YET_M = 50;

/**
 * { distanceM, tiles, points } -> { empty, text }.
 * empty = retkellä ei ole kertynyt oikeastaan mitään (selvästi vahingossa aloitettu).
 */
export function discardSummary({ distanceM = 0, tiles = 0, points = 0 }) {
  const empty = distanceM < NOTHING_YET_M && tiles <= 0 && points <= 0;
  if (empty) return { empty: true, text: "Retkelle ei ole vielä kertynyt mitään. Se poistetaan tallentamatta." };
  const parts = [`${(distanceM / 1000).toLocaleString("fi-FI", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} km`];
  if (tiles > 0) parts.push(plural(tiles, "uusi ruutu", "uutta ruutua"));
  if (points > 0) parts.push(plural(points, "piste", "pistettä"));
  const list = parts.length > 1 ? `${parts.slice(0, -1).join(", ")} ja ${parts.at(-1)}` : parts[0];
  return { empty: false, text: `Retkeä ei tallenneta. Siitä poistuvat ${list}. Tätä ei voi perua.` };
}
